import { useEffect } from 'react'
import { Outlet, Navigate, useMatch } from 'react-router-dom'
import { useSelector } from 'react-redux';
import Cookies from 'universal-cookie';
import Login from "../pages/Login";

const PrivateRoutes = () => {
    const cookies = new Cookies();
    const userEmail = cookies.get('userEmail')
    const loginPage = useMatch('/login');

    return(
        userEmail !== '' &&  userEmail !== undefined ? <Outlet/> : ( loginPage ? <Login/> : <Navigate to="/login"/> )
    )
}

export default PrivateRoutes